import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {gsap} from "gsap";
import {FlightMode} from "../FlightMode";
import {FlightModeSymbol} from "../objects/FlightModeSymbol";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class NormalReelStop implements SimplePresentation {

    shouldRun(): boolean {
        return true;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const isFastDrops = FlightMode.apiPlugin.settings.get(APISetting.FAST_SPIN);
        const tl:gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
            }
        });

        // drop in for a full screen of symbols is just below 0.5s
        const jurPadding = FlightMode.gameFlowController.calculatePaddingDuration(0.5);
        tl.add(() => {}, `>${jurPadding + 0.1}`);

        tl.add(() => {
            //controller.setSkipCallback(() => {tl.progress(1, false)})
            FlightMode.backgroundElements.fadeOutNoWin();
        })

        FlightMode.reelView.resetLandSounds();

        const newSymbols = FlightMode.model.reels.map(
            (reel, reelIndex) => reel.map(
                (symbol, rowIndex) =>
                    new FlightModeSymbol(symbol, FlightMode.model.symbolSizes[reelIndex][rowIndex])));
        const dropInTimeline = isFastDrops
                               ? FlightMode.reelView.dropInSymbolsInstant(newSymbols)
                               : FlightMode.reelView.dropInSymbols(newSymbols)
        tl.add(dropInTimeline);
        if (FlightMode.model.isNotAvalanche()) {
            tl.add(() => {
                FlightMode.soundPlayer.playSound("symFallIn");
            }, '<')
        }

        const shouldPad = dropInTimeline.duration() > 0 && dropInTimeline.duration() < 0.31;
        const padding = shouldPad ? 0.31 - dropInTimeline.duration() : ""

        tl.add(() => {
            controller.finish()
        }, false ? `>${padding}` : "+=0");

        tl.add(() => {
            controller.setSkipCallback(() => {tl.progress(1, false)})
        }, 0.35)
    }
}
